// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  useEmulators: false,

  firebase: {
    projectId: "brm-cloud-dev",
    appId: "1:854391822774:web:a8920e9f54787d50494917",
    databaseURL: "https://brm-cloud-dev.firebaseio.com",
    storageBucket: "brm-cloud-dev.appspot.com",
    locationId: 'europe-west',
    apiKey: "AIzaSyCBYZ-iVszm0uTMFi_thkXigH_lGYYcDyw",
    authDomain: "brm-cloud-dev.firebaseapp.com",
    messagingSenderId: "854391822774"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
